var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',{attrs:{"title":"Expense Type"}},[_c('load-table')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }